// src/hooks/useScroll.ts

import { useEffect } from 'react';

type ScrollHandler = (event: Event) => void;

/**
 * 自定义 Hook，用于监听滚动和触摸事件
 * @param handler - 处理事件的回调函数
 */
const useScroll = (handler: ScrollHandler) => {
    useEffect(() => {

        console.log(`初始化 useScroll`)
        const handleEvent = (event: Event) => {
            handler(event);
        };

        // 添加事件监听器
        window.addEventListener('scroll', handleEvent, { passive: true });
        document.addEventListener('touchstart', handleEvent, { passive: true });
        document.addEventListener('touchmove', handleEvent, { passive: true });
        document.addEventListener('touchend', handleEvent, { passive: true });

        // 清理事件监听器
        return () => {
            window.removeEventListener('scroll', handleEvent);
            document.removeEventListener('touchstart', handleEvent);
            document.removeEventListener('touchmove', handleEvent);
            document.removeEventListener('touchend', handleEvent);
        };
    }, [handler]);
};

export default useScroll;
